goog.provide("shadow.js.shim.module$date_fns$formatDistanceToNowStrict$default");
shadow.js.shim.module$date_fns$formatDistanceToNowStrict$default = esm_import$date_fns$formatDistanceToNowStrict.default;
